/**
 * auth认证（令牌）
 * 之前用户信息存储位置是：sessionStorage，关闭浏览器登录失效
 * 保持登录状态：refresh_token结合localStorage来延长token有效期
 * token: {token, refresh_token}
 */
const GY_TOKEN = 'LGTOKEN'
const GY_campusId = 'LG_campusId'
export function getTokenName() {
  return GY_TOKEN
}
// 存储token
export function setToken (token) {
  localStorage.setItem(getTokenName(), token)
}
// 获取token
export function getToken () {
  try {
    return localStorage.getItem(getTokenName())
  } catch (err) {
    throw new Error({ err })
  }
}
// 删除token
export function removeToken () {
  localStorage.removeItem(getTokenName())
}
// 存储校区Id
export function setCampusId (campusId) {
  sessionStorage.setItem(GY_campusId, campusId)
}
// 获取校区Id
export function getCampusId () {
  return sessionStorage.getItem(GY_campusId) || ''
}
